'use strict';

var KeyMirror = require('keymirror');

var linkAccountOptions = {
    investor1: 'investor1',
    investor2: 'investor2',
    dontLink: 'dontLink'
}
var rebateOptions = {
    moreConservative: 'moreConservative',
    selectOption: 'selectOption'
}

module.exports = {
    ActionTypes: KeyMirror({
        UPDATE_PORTFOLIO_REBATE_DATA: null,
        VALIDATE: null,
        REVIEW: null
    }),
    LINK_ACCOUNT_DATA: [
    {
        id: linkAccountOptions.investor1,
        name: 'Investor 1 portfolio',
        confirmDetailsDisplay: 'Investor 1'
    }, {
        id: linkAccountOptions.investor2,
        name: 'Investor 2 portfolio',
        confirmDetailsDisplay: 'Investor 2'
    }, {
        id: linkAccountOptions.dontLink,
        name: 'Do not link this account',
        confirmDetailsDisplay: 'Not selected'
    }],

    RADIO_INPUT_DATA: [{ id: rebateOptions.moreConservative, name: 'More conservative', isHidden: false }, { id: rebateOptions.selectOption, name: 'Select option', isHidden: false }],

    PortfolioRebateValues: {
        MORE_CONSERVATIVE: rebateOptions.moreConservative,
        SELECT_OPTION: rebateOptions.selectOption
    },

    LinkAccountOptions: {
        INVESTOR1: linkAccountOptions.investor1,
        INVESTOR2: linkAccountOptions.investor2,
        DONT_LINK: linkAccountOptions.dontLink
    },
    Labels: {
        creditedTo: 'Credited to',
        nominatedPortfolio: 'Nominated portfolio(s)'
    },
    Values: {
        moreConservative: 'More conservative option'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/PortfolioRebateConstants.js